/*
 * @Description: '错误'页面所有路由
*/

export default [
    {
        path: '/error-500',
        component: resolve => require(['@/views/error/500'], resolve),
        name: 'Error-500'
    },
    {
        path: '*',
        component: resolve => require(['@/views/error/404'], resolve),
        name: 'Error-404'
    }
      
]


// WEBPACK FOOTER //
// ./src/router/error.js